module.exports = __webpack_public_path__ + "img/angle-down.614cdf76.svg";